module.exports = __webpack_public_path__ + "static/media/servicestreeen@2x.a0c69cde.png";